export default {
      id: "user-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#user",
      toString: function () {
        return this.url;
      }
    }